var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{style:(_vm.style)},[_c('v-img',{attrs:{"src":_vm.src,"contain":"","max-width":_vm.maxWidth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }